const PayType = `
  name
  numberId
  tax
  updatedAt
  cd
  receipt
`;

export default PayType;
